<template>
  <!-- 主容器，负责左右内容的排列 -->
  <div class="card-top-bar">
    <!-- 左侧部分（图标和标题） -->
    <div class="left-content">
      <div class="icon"></div>
      <div class="title">{{ title }}</div>
    </div>

    <!-- 右侧部分，这里是我们为外部内容预留的插槽 -->
    <div class="right-content">
      <slot name="extra"></slot>
    </div>
  </div>
  <div class="separator"></div>
</template>

<script>
export default {
  name: 'CardTopBar', // 推荐为组件添加 name 属性
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.card-top-bar {
  display: flex;
  justify-content: space-between; /* 关键：让左右内容两端对齐 */
  align-items: center; /* 垂直居中对齐 */
  height: 20px;
  background-color: #fff;
}

/* 将左侧的图标和标题组合在一起 */
.left-content {
  display: flex;
  align-items: center;
}

.icon {
  height: 100%;
  width: 4px;
  background-color: #4021ef;
  border-radius: 1px;
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-left: 8px;
}

/* 右侧内容的容器，可以根据需要添加样式 */
.right-content {
  display: flex;
  align-items: center;
}

.separator {
  margin-top: 8px;
  margin-bottom: 8px;
  height: 1px;
  background-color: #d9d9d9;
  width: 100%;
}
</style>